const ads = {
  interstitialPath: '231599934,4541908/nationtv/interstital-ads/interstital-ads'
};
export default { ...ads };
